import { getImageFromBase64 } from 'services/magazineService'
import { DEFAULT_PAGE, STORAGE_TOKEN_KEY } from '../configs/constant'
import { notifyError } from './Notification'
import * as encoding from 'encoding-japanese'
// bind url with params
export const bindParams = (str: string, params: any = {}) => {
  let result = str
  for (const key in params) {
    result = result.replace(new RegExp(`:${key}`, 'g'), params[key])
  }
  return result
}

export const scrollToErrorField = ({ errorFields }: any) => {
  const el = document.getElementById(errorFields[0].name[0]) as HTMLElement
  el.scrollIntoView()
  window.scrollTo(0, window.scrollY - el.offsetHeight - 300)
}

export const checkLogin = () => {
  return !!localStorage.getItem(STORAGE_TOKEN_KEY)
}

export const handleFinishFailed = (errorInfo: any) => {
  if (errorInfo.errorFields) {
    notifyError({
      message: '入力が不足している項目があります。'
    })
  }
}

export const getAllDaysInMonth = (month: number, year: number) =>
  Array.from({ length: new Date(year, month, 0).getDate() }, (_, i) => new Date(year, month - 1, i + 1).getDate())

export const checkOverMaxByte = (text: string, max: number) => {
  const utf16Array = Array.from(text).map((char) => char.charCodeAt(0))
  const byteLength = encoding.convert(utf16Array, { to: 'EUCJP' }).length
  return byteLength <= max
}

export const countByteCharacter = (text: string) => {
  const utf16Array = Array.from(text).map((char) => char.charCodeAt(0))
  const byteLength = encoding.convert(utf16Array, { to: 'EUCJP' }).length
  return byteLength
}

export const truncateToMaxByte = (text: string, max: number): string => {
  let byteLength = 0
  let result = ''

  for (let i = 0; i < text.length; i++) {
    const char = text.charAt(i)
    const charCodeArray = [char.charCodeAt(0)]
    const charBytes = encoding.convert(charCodeArray, { to: 'EUCJP' }).length

    if (byteLength + charBytes > max) {
      break
    }

    result += char
    byteLength += charBytes
  }

  return result
}

export const handleConvertDataToTable = (dataList: any[], page: number, perPage: number) => {
  return dataList.map((noti: any, index: number) => {
    return {
      ...noti,
      key: (page - 1) * perPage + index + 1
    }
  })
}

export const appendDataToFormData = (formData: any, dataInput: any) => {
  Object.keys(dataInput).forEach((key1) => {
    if (dataInput[key1 as keyof typeof dataInput] !== undefined) {
      if (Array.isArray(dataInput[key1 as keyof typeof dataInput]) && key1 !== 'table_of_contents') {
        const valueOfKey1 = dataInput[key1 as keyof typeof dataInput] as any[]
        valueOfKey1.forEach((value: any, index: number) => {
          formData.append(`${key1}[${index}]`, value)
        })
      } else if (
        typeof dataInput[key1 as keyof typeof dataInput] === 'object' &&
        key1 !== 'file_upload' &&
        key1 !== 'banner_image' &&
        key1 !== 'table_of_contents'
      ) {
        const valueOfKey1 = dataInput[key1 as keyof typeof dataInput] as any[]
        Object.keys(valueOfKey1).forEach((value: any) => {
          formData.append(`${key1}[${value}]`, valueOfKey1[value])
        })
      } else if (key1 === 'file_upload') {
        formData.append('file_upload', dataInput['file_upload'])
      } else if (key1 === 'banner_image') {
        formData.append('banner_image', dataInput['banner_image'])
      } else if (key1 === 'table_of_contents') {
        dataInput[key1 as keyof typeof dataInput].forEach(
          (
            items: {
              page: number
              title: string
            },
            index: number
          ) => {
            formData.append(`table_of_contents[${index}][page]`, items.page)
            formData.append(`table_of_contents[${index}][title]`, items.title)
          }
        )
      } else {
        const itemData = dataInput[key1 as keyof typeof dataInput] as string
        formData.append(key1, itemData)
      }
    }
  })
}

export const actionAfterCreateSuccess = (page: number, lastPage: number, total: number, perPage: number, funcGetList: any, setStatePage: any) => {
  if (page === lastPage) {
    if (total % perPage !== 0) {
      funcGetList()
    } else {
      setStatePage(lastPage + 1)
    }
  } else if (total % perPage !== 0) {
    setStatePage(lastPage)
  } else {
    setStatePage(lastPage + 1)
  }
}

export const actionAfterCreateSuccess_2 = (page: number, funcGetList: any, setStatePage: any) => {
  if (page === DEFAULT_PAGE) {
    funcGetList()
  } else {
    setStatePage(DEFAULT_PAGE)
  }
}

export const getFileNameFormUrl = (url: string) => {
  if (!url || !url.includes('/')) return url
  const lastIndex = url.split('/').length - 1
  return url.split('/')[lastIndex]
}

export const expandRange = (range: string): number[] => {
  const resultArray = []
  const [start, end] = range.split('-').map(Number)
  if (start < end) {
    for (let i = start; i <= end; i++) {
      resultArray.push(i)
    }
  } else if (start > end) {
    for (let i = start; i >= end; i--) {
      resultArray.push(i)
    }
  } else {
    resultArray.push(start)
    resultArray.push(end)
  }
  return resultArray
}

export const parseStringToArray = (str: string): number[] => {
  return String(str)
    .split(',')
    .flatMap((part) => (part.includes('-') ? expandRange(part) : [Number(part)]))
}

export const checkingPageSingle = (pages: number[], numPages: number) => {
  let checking = true
  pages.forEach((page, index) => {
    if (page > numPages) {
      checking = false
      return checking
    }
    if (index === 0 && !(page % 2)) {
      checking = false
      return checking
    }
    if (index > 0) {
      if (page <= pages[index - 1]) {
        checking = false
        return checking
      }
      if (!((page - pages[index - 1]) % 2)) {
        checking = false
        return checking
      }
    }
  })
  return checking
}
export const checkingPageTrial = (pages: number[], numPages: number) => {
  let checking = true
  // if (type === PageViewType.DOUBLE_PAGE) {
  //   checking = checkingPageSingle(pages, numPages)
  //   return checking
  // }
  pages.forEach((page, index) => {
    if (page > numPages) {
      checking = false
      return checking
    }
    if (index > 0) {
      if (page <= pages[index - 1]) {
        checking = false
        return checking
      }
    }
  })
  return checking
}

type Nullable<T> = {
  [P in keyof T]: T[P] | null
}

export const checkingTableContent = (dataTableOfContent: any[], numPages: number) => {
  let checking = true
  dataTableOfContent.forEach((value) => {
    // const match = value.match(/^\s*(\S+)\s+(\S+)\s*$/)
    const match = value.match(/^(.*)\t+(\d+)$/)
    if (match) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
      const [, key, value] = match
      if (value < 1 || value > numPages) {
        checking = false
        return checking
      }
      if (!key.length) {
        checking = false
        return checking
      }
    } else if (match === null) {
      checking = false
      return checking
    }
  })
  return checking
}

export const filterNonNullValues = <T>(obj: Nullable<T>): Partial<T> =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null)) as Partial<T>

export const readFileTxt = async (fileUrl: string) => {
  try {
    const res = await fetch(fileUrl)
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`)
    }
    const text = await res.text()
    return text
  } catch (e) {
    return null // or handle the error in a way that makes sense for your application
  }
}

export const renderReadTrial = (domain: string, app: string, magazineId: number) => {
  return `${domain}/${app}/view?magazineId=${magazineId}&isPreview=true`
}

export const handleGetThumbnail = async (pdf: any) => {
  // Fetch the first page
  const page = await pdf.getPage(1)
  const scale = 1.5
  const viewport = page.getViewport({ scale })
  const outputScale = window.devicePixelRatio || 1

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  canvas.width = Math.floor(viewport.width * outputScale)
  canvas.height = Math.floor(viewport.height * outputScale)
  canvas.style.width = Math.floor(viewport.width) + 'px'
  canvas.style.height = Math.floor(viewport.height) + 'px'

  const transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null
  const renderContext = {
    canvasContext: context,
    transform,
    viewport
  } as any
  await page.render(renderContext).promise
  const base64Image = canvas.toDataURL('image/png')
  const thumnail = await getImageFromBase64([base64Image])
  if (thumnail.error && !thumnail.success) {
    throw new Error('Error while getting thumbnail')
  }
  return thumnail
}

export const hasDuplicateProductId = (array: any[]) => {
  const ids = new Set();

  return array.some(item => {
    const id = item.product_id?.trim();
    if (id && ids.has(id)) {
      return true;
    }
    if (id) {
      ids.add(id);
    }
    return false;
  });
}


export const hasDuplicateAndroidProductId = (array: any[]) => {
  const ids = new Set();

  return array.some(item => {
    const id = item.android_product_id?.trim();
    if (id && ids.has(id)) {
      return true;
    }
    if (id) {
      ids.add(id);
    }
    return false;
  });
}

export const convertDataTableContent = (dataTableOfContent: any[]) => {
  const contentMap = dataTableOfContent.reduce((acc, currentValue) => {
    const match = currentValue.match(/^(.*)\t+(\d+)$/)
    if (match) {
      const [, key, value] = match
      const numericValue = parseInt(value, 10)
      let found = false
      for (const entry of acc) {
        if (entry.key === numericValue) {
          entry.values.push(key)
          found = true
          break
        }
      }
      if (!found) {
        acc.push({ key: numericValue, values: [key] })
      }
    }
    return acc
  }, [] as { key: number; values: string[] }[])

  const data: any[] = []
  for (const item of contentMap) {
    for (const value of item.values) {
      data.push({
        page: item.key,
        title: value
      })
    }
  }
  return data
}

export const deleteCookie = (name: string) => {
  document.cookie = name + `=; expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${process.env.REACT_APP_DOMAIN}; path=/`
}

export const createCSVWithProperEncoding = (csvContent: string): Blob => {
  const BOM = '\uFEFF'
  const contentWithBOM = BOM + csvContent
  
  return new Blob([contentWithBOM], { 
    type: 'text/csv;charset=utf-8' 
  })
}

export const readCSVFileWithEncoding = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    
    reader.onload = (e: any) => {
      try {
        const content = e.target.result
        
        if (content.charCodeAt(0) === 0xFEFF) {
          resolve(content.slice(1))
        } else {
          resolve(content)
        }
      } catch (error) {
        reject(error)
      }
    }
    
    reader.onerror = () => {
      reject(new Error(''))
    }
    
    reader.readAsText(file, 'utf-8')
  })
}

